import {Button, Col, Radio, Input, Row, Space, Typography, Form} from "antd";
import React, {useEffect, useState} from "react";
import Icons from "assets/icons";
import "./LensExpand.scss";
import {DataInputField, InputFields} from "components/common";
import Icon from "@ant-design/icons";
import {FieldsLens1, FieldsLens2} from "./LensExpand.config";
import {useAppSelector} from "redux/hooks";

type Props = {
  isOpen: boolean;
  setIsOpen: () => void;
  index: number;
};

const LensExpand: React.FC<Props> = ({isOpen, setIsOpen, index}) => {
  const objectChanDoan = useAppSelector(
    state => state.examination.objectChanDoan
  );
  const ref = useAppSelector(state => state.examination.ref);
  const defaultValues = {
    "Hình thái": "Trong",
    "Vị trí": "Trung tâm",
    "Kích thước": "Bình thường",
    "Phân loại LOCS": null,
    NS: null,
    C: null,
    P: null,
    "Ghi chú": null,
  };
  useEffect(() => {
    if (!isOpen) {
      // const fieldsValue = ref.getChanDoanValue();
      if (ref) {
        ref.setFieldValue(
          [`${index == 1 ? "leftJsonValue" : "rightJsonValue"}`, "LENS"],
          defaultValues
        );
      }
    }
    if (ref) {
      ref.setFieldValue(
        [`${index == 1 ? "leftJsonValue" : "rightJsonValue"}`, "LENS", "show"],
        isOpen
      );
    }
  }, [isOpen, ref]);
  useEffect(() => {
    if (objectChanDoan && ref) {
      const show = ref.getFieldValue([
        `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
        "LENS",
        "show",
      ]);
      if (Boolean(show) == true && isOpen == false) {
        setIsOpen();
      }
      if (Boolean(show) == false && isOpen == true) {
        setIsOpen();
      }
    }
  }, [objectChanDoan, ref]);
  return (
    <Space
      direction="vertical"
      className="space-common space-lens"
      size={"middle"}
    >
      <Row justify={"start"} className="row-common">
        <Button
          type="primary"
          icon={isOpen ? <Icons.sub /> : <Icons.add />}
          onClick={setIsOpen}
        />
        <Typography className="title-common-healthy">THỦY TINH THỂ</Typography>
      </Row>

      {isOpen ? (
        <div>
          <Row gutter={[16, 16]}>
            <InputFields data={index === 0 ? FieldsLens1 : FieldsLens2} />

            {/* <Col span={24}>
              <Button style={{background: "#003828", color: "#FFFFFF"}}>
                Add Cornea Diagram
              </Button>
            </Col> */}
          </Row>
        </div>
      ) : null}
    </Space>
  );
};

export default LensExpand;
